import { useQuery } from "@tanstack/react-query"
import DataService from "../services/DataService"

export default function useCustomCategories() {
    const {
        data: customCategories = [],
    } = useQuery({ queryKey: ['customCategories'], queryFn: DataService.getCustomCategories, refetchOnWindowFocus: false })
    return customCategories
}